import { Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";

interface DateRangePickerProps {
  start: dayjs.Dayjs,
  end: dayjs.Dayjs,
  setDate: (inicio: dayjs.Dayjs, fin: dayjs.Dayjs) => void;
  handleChange: () => void;
}

export default function DateRangePickerComponent({ start, end, setDate, handleChange } : DateRangePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <Box sx={{ display: "flex", gap: 2 }}>
        <DatePicker
          label="Desde"
          value={start}
          format="DD/MM/YYYY"
          onChange={(newValue) => {
            if (!newValue) return;
            const nuevoFin = end.isBefore(newValue) ? newValue : end;
            setDate(newValue, nuevoFin);
            handleChange()
          }}
          slotProps={{ 
            textField: { 
              size: "small",
              inputProps: {
                placeholder: "DD/MM/YYYY"
              }
            } 
          }}
        />
        <DatePicker
          label="Hasta"
          value={end}
          format="DD/MM/YYYY"
          onChange={(newValue) => {
            if (!newValue) return;
            const nuevoInicio = start.isAfter(newValue)
              ? newValue
              : start;
            setDate(nuevoInicio, newValue);
            handleChange()
          }}
          slotProps={{ 
            textField: { 
              size: "small",
              inputProps: {
                placeholder: "DD/MM/YYYY"
              }
            } 
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
